import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RDDarkService } from './../dark.service';

@Component({
  selector: 'rd-confirm-modal',
  template: `<div class="modalContainer" [class.open]="isOpen()" [class.rdDark]="dark" (click)="closeModal()">
  <div class="modalPanel" [style.width.%]="width" [style.maxHeight.%]="maxHeight" (click)="clickOnModal($event)">
    <ng-content></ng-content>
    <div class="buttonLine">
      <rd-button [color]="'red'" (buttonClick)="cancel($event)">{{cancelText}}</rd-button>
      <rd-button [color]="'green'" (buttonClick)="accept($event)">{{acceptText}}</rd-button>
    </div>
  </div>
</div>
`,
  styles: [`.modalContainer{--background-color:rgba(241, 241, 241, 0.8);--background-modal:white;--text-color:black;position:fixed;top:0;left:0;width:100%;height:100%;background-color:var(--background-color);color:var(--text-color);display:none;z-index:10}.modalContainer.open{display:block}.modalContainer .modalPanel{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background-color:var(--background-modal);box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);overflow-x:hidden;overflow-y:auto;box-sizing:border-box}.modalContainer .modalPanel .buttonLine{display:flex;justify-content:space-around;padding:6px;flex-wrap:wrap-reverse}.modalContainer .modalPanel .buttonLine>*{width:30%;min-width:100px}@media screen and (max-width:640px){.modalContainer .modalPanel .buttonLine>*{width:100%;padding-bottom:6px}}.modalContainer.rdDark{--background-color:rgba(7, 56, 76, 0.8);--background-modal:#0d2a35;--text-color:white}`]
})
export class RDConfirmModalComponent implements OnInit {

  @Input() width = 50;
  @Input() maxHeight = 80;
  @Input() acceptText = 'Accept';
  @Input() cancelText = 'Cancel';

  @Output() closedModal: EventEmitter<any> = new EventEmitter();
  @Output() cancelModal: EventEmitter<any> = new EventEmitter();
  @Output() acceptModal: EventEmitter<any> = new EventEmitter();

  private open = false;
  public dark = true;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  openModal() {
    this.open = true;
  }

  closeModal() {
    this.open = false;
    this.closedModal.emit();
  }

  clickOnModal(event) {
    event.stopPropagation();
  }

  accept(event) {
    event.stopPropagation();
    this.acceptModal.emit(event);
    this.closeModal();
  }

  cancel(event) {
    event.stopPropagation();
    this.cancelModal.emit(event);
    this.closeModal();
  }

  isOpen() {
    return this.open;
  }

}
